import { isGoogleDemandUrl } from './googleAdSuitability.js';

export function videoTagWithConsent(tagUrl, preferences = {}) {
  if (!isGoogleDemandUrl(tagUrl)) return tagUrl;
  if (preferences.decided !== true || preferences.advertising !== true) return '';
  const npa = preferences.personalization === true ? '0' : '1';
  // Preserve GAM macro spelling until the IMA request replaces the cachebuster.
  const tag = String(tagUrl);
  return /([?&])npa=[^&]*/i.test(tag)
    ? tag.replace(/([?&])npa=[^&]*/gi, `$1npa=${npa}`)
    : `${tag}${tag.includes('?') ? '&' : '?'}npa=${npa}`;
}
